import type { FC } from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const DragDropVerticalIcon: FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33301 4.5H5.33724M5.33301 8.5H5.33724M5.33301 12.5H5.33724M10.6621 4.5H10.6663M10.6621 8.5H10.6663M10.6621 12.5H10.6663"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
